import React from 'react';
import { Card, CardContent } from '../Card';
import { Badge } from '../Badge';
import { Sparkles, Zap, Info } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PrioritasAICallout() {
  const keywords = ['Deepfake Presiden', 'Harga beras', 'Bot network', 'Papua visit', 'Bansos', 'TNI / BAIS', 'Hilirisasi', 'IKN', 'Anies Baswedan', 'IPOLEKSOSBUDHANKAM'];
  return <Card className="bg-gradient-to-br from-primary/5 via-card to-card border-primary/20" data-id="element-836">
      <CardContent className="p-4 sm:p-5" data-id="element-837">
        <div className="flex items-start gap-3" data-id="element-838">
          <div className="size-10 rounded-lg bg-primary/10 border border-primary/30 flex items-center justify-center shrink-0" data-id="element-839">
            <Zap className="size-5 text-primary" data-id="element-840" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-841">
            <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-842">
              <Badge variant="outline" className="font-mono text-[9px] h-5 px-1.5 bg-primary/10 text-primary border-primary/30" data-id="element-843">
                <Sparkles className="size-2.5 mr-1" data-id="element-844" />
                AI EXPLAINABILITY
              </Badge>
              <span className="font-mono text-[9px] uppercase tracking-wider text-muted-foreground" data-id="element-845">
                Updated 2 menit lalu
              </span>
            </div>
            <h3 className="font-heading text-sm font-bold tracking-tight" data-id="element-846">
              Prioritas AI
            </h3>
            <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed" data-id="element-847">
              Isu di atas dipilih berdasarkan prioritas pemrosesan AI berikut —
              dapat di-tuning di{' '}
              <Link to="/ai-config" className="text-primary hover:underline font-medium" data-id="element-848">
                AI Configuration
              </Link>
              .
            </p>
          </div>
        </div>

        <div className="mt-3.5 grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-849">
          {/* Reasoning */}
          <div className="md:col-span-2 rounded-lg border border-border/60 bg-card p-3" data-id="element-850">
            <p className="font-mono text-[9px] uppercase tracking-wider text-muted-foreground font-bold mb-1.5" data-id="element-851">
              Reasoning
            </p>
            <p className="text-xs text-foreground/80 leading-relaxed" data-id="element-852">
              Prioritas utama berfokus pada isu{' '}
              <b data-id="element-853">keamanan informasi (deepfake)</b> dan{' '}
              <b data-id="element-854">stabilitas ekonomi pangan</b> karena cakupan dampaknya paling
              luas, lalu diikuti isu <b data-id="element-855">operasi terkoordinasi politik</b> dan
              ancaman terhadap <b data-id="element-856">agenda kunjungan Presiden</b>. AI Analyst
              menilai 4 isu ini perlu eskalasi dalam 24 jam.
            </p>
            <div className="flex items-start gap-1.5 mt-2 pt-2 border-t border-border/60" data-id="element-857">
              <Info className="size-3 text-muted-foreground shrink-0 mt-0.5" data-id="element-858" />
              <p className="text-[10px] text-muted-foreground leading-relaxed" data-id="element-859">
                Confidence: <b className="text-emerald-700" data-id="element-860">92%</b> · Model:
                Garuda-LLM v4.1 · Human-in-the-loop · Audit trail tercatat.
              </p>
            </div>
          </div>

          {/* Keywords */}
          <div className="rounded-lg border border-border/60 bg-card p-3" data-id="element-861">
            <p className="font-mono text-[9px] uppercase tracking-wider text-muted-foreground font-bold mb-1.5" data-id="element-862">
              Kata Kunci ({keywords.length})
            </p>
            <div className="flex flex-wrap gap-1" data-id="element-863">
              {keywords.map(k => <span key={k} className="font-mono text-[9px] px-1.5 py-0.5 rounded bg-primary/5 text-primary border border-primary/20" data-id="element-864">
                  {k}
                </span>)}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>;
}